import { styled } from '@grupoboticario/flora-react';

import { ResponsiveFloraTypography } from 'components/ResponsiveFloraTypography';

export const styles = {
  Text: styled(ResponsiveFloraTypography, {
    color: '$linkDefault',
    textDecoration: 'underline',
    display: 'inline',

    '&:hover': {
      color: '$linkHover',
    },
  }),
};

export default styles;
